import React from "react";

const handleOnlinePayments = (props) => {
  const options = [
    {
      text: 'Help, I’m concerned about my Interac Debit for online transaction.',
      handler: props.actionProvider.handleOnlinePayments1,
      id: 1,
    },
    {
      text: 'Is there a limit to how much I can spend via Interac Online?',
      handler: props.actionProvider.handleOnlinePayments2,
      id: 2
    },
    {
      text: 'How much does it cost to use Interac online payments?',
      handler: props.actionProvider.handleOnlinePayments3,
      id: 3
    },
    {
      text: 'What if I don’t have online banking?',
      handler: props.actionProvider.handleOnlinePayments4,
      id: 4
    },
    {
      text: 'Who do I call if something goes wrong when I use Interac online payments?',
      handler: props.actionProvider.handleOnlinePayments5,
      id: 5
    },
    {
      text: 'I’m not sure if my online payment was completed. How do I know?',
      handler: props.actionProvider.handleOnlinePayments5,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleOnlinePayments;